// @flow

import {isBrowser} from './isBrowser';

type OS = 'mac' | 'ios' | 'windows' | 'linux' | 'unknown';

/*
Due to SSR, we cannot easily detect the OS server side.
*/
export const getUserOS = (): OS => {
  if (isBrowser && typeof navigator === 'object' && navigator.platform) {
    const platform = navigator.platform.toLowerCase();
    if (platform.includes('mac')) {
      return 'mac';
    } else if (platform.includes('ios')) {
      return 'ios';
    } else if (platform.includes('windows')) {
      return 'windows';
    } else if (platform.includes('linux')) {
      return 'linux';
    } else {
      return 'unknown';
    }
  } else {
    // We can potentially thread the user agent from the HTTP
    // into docs-srv an infer here if we want to.
    return 'unknown';
  }
};
